import { FlashContextInterface, FlashType, withFlashContext } from '@amzn/awscat-react-components';
import { Flashbar, FlashbarProps } from '@amzn/awsui-components-react';
import { useEffect, useState } from 'react';

import { constants } from '../common/Localization';

type AggregatedFlashMessage = {
    type: FlashType;
    header: string;
    content: string;
    ids: string[];
};

const SUCCESS_BANNER_LIFETIME = 3000;
function FlashMessages(props: FlashContextInterface) {
    const [ messageItems, setMessageItems ] = useState<FlashbarProps.MessageDefinition[]>([]);
    const flashes = props.flash.flashes;
    const getFlashItems = (): FlashbarProps.MessageDefinition[] => {
        if (!flashes || flashes.length === 0) {
            return [];
        }
        const aggregatedFlashMessagesMap = flashes.reduce((items, flashMessage) => {
            const { type, header, content, id } = flashMessage;
            const key = `${content}-${type}`;
            const flashItem = items.get(key) ?? {content, type, header, ids: []};
            flashItem.ids.push(id);
            items.set(key, flashItem);
            return items;
        }, new Map<string, AggregatedFlashMessage>());

        const itemsToDisplay: FlashbarProps.MessageDefinition[] = [];
        aggregatedFlashMessagesMap.forEach(aggregatedMessage => {
            const { content, ids, type, header} = aggregatedMessage;
            const countContent = ids.length > 1 ? `(${ids.length})` : '';
            itemsToDisplay.push({
                type,
                dismissible: true,
                dismissLabel: constants.DISMISS_MESSAGE,
                onDismiss: () => {
                    props.flash.removeAll(ids);
                },
                content: `${content} ${countContent}`,
                header
            });
        });
        return itemsToDisplay;
    };

    useEffect(() => {
        const items = getFlashItems();
        setMessageItems(items);
        const successItems = items.filter(item => item.type === FlashType.success);

        if (successItems.length > 0) {
            setTimeout(() => {
                props.flash.removeAll(props.flash.flashes.filter(flash => flash.type === FlashType.success).map(flash => flash.id));
                const nonSuccessItems = items.filter(item => item.type !== FlashType.success);
                setMessageItems(nonSuccessItems);
            }, SUCCESS_BANNER_LIFETIME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.flash.flashes ]);

    return <Flashbar items={messageItems} />;
}

export default withFlashContext(FlashMessages);
